import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CreateArtifactContext } from "../../../../../context/CreateArtifactContext";

import { capitalizeFirstLetter } from "../../../../../utils/stringFunctions";
import { ContentState, getContentStatusString } from "../../../../../models/SKArtifact";
import { Link } from "react-router-dom";
import { format } from "date-fns";

interface ContentReportNavigatorProps {
  title?: string;
}

export default function ContentReportNavigator({ title = "Content Reports" }: ContentReportNavigatorProps) {
  const { contentData } = useContext(CreateArtifactContext);

  return (
    <div className="relative w-full min-w-[200px] ">
      <div className="flex items-center pb-[10px]">
        <span className="content_title">{title}</span>
      </div>
      <div
        id="content-item"
        className="cursor-pointer input-content-topic"
        tabIndex={0}
        // onClick={() => {
        //   contentId && navigate("../history", { state: { channelId: contentId } });
        // }}
      >
        <Link to={`reports`} className="flex items-center justify-between w-full">
          <div id="topic" className="flex input-content-topic-text">
            View Reports
          </div>

          <div id="title" className="flex m-[15px] items-center gap-[5px]">
            <span className="bg-skred w-[8px] h-[8px] min-h-2 min-w-2 rounded-full"></span>
            <div className="input-content-topic-title">
              {`${contentData.lastReportedDate ? format(contentData.lastReportedDate.toDate(), "MMM, dd yyyy") : "--"} (${contentData.reportCount})`}
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
}
